{
  "dashboard": {
    "section_title": "Your Objectives",
    "item": {
      "target_date_prefix": "Target date - "
    }
  },
  "progress": {
    "actions": {
      "remove": "remove objective progress",
      "edit": "Edit",
      "delete": "Delete"
    },
    "confirmation": {
      "remove_title": "Remove progress",
      "remove_content": "Are you sure you want to remove this progress?"
    },
    "form": {
      "create_button": "Create Progress",
      "update_button": "Update Progress",
      "target_description": "Your target is",
      "current_value": "Current value is",
      "comment_label": "Comment",
      "checkin_date_label": "Check in date"
    },
    "status": {
      "updated_value": "updated the value to {{value}}"
    }
  },
  "form": {
    "create_title": "Create Objective",
    "update_title": "Update Objective",
    "objective_label": "Objective",
    "objective_placeholder": "Objective",
    "description_label": "Description",
    "description_placeholder": "Description",
    "owners_label": "Owners",
    "owners_placeholder": "Owners",
    "target_date_label": "Target Date",
    "target_date_placeholder": "Target Date",
    "unit_aria_label": "Unit"
  },
  "measure": {
    "title": "Measure",
    "unit_label": "Unit",
    "custom_unit_placeholder": "Specify your custom unit here",
    "preview_label": "Preview:",
    "target_label": "Target",
    "target_placeholder": "Target Value",
    "initial_label": "Initial",
    "initial_placeholder": "Initial Value",
    "new_amount_placeholder": "Please enter the new amount",
    "client_unit": "Client"
  },
  "validation": {
    "title_required": "Please add a title for the Objective",
    "title_max_length": "Must be less than 160 characters",
    "target_date_required": "Please enter a target date",
    "owners_required": "Please add at least one owner",
    "target_value_required": "Please add a Target",
    "target_value_positive": "Please enter a positive amount",
    "initial_value_positive": "Please enter a positive amount",
    "measure_value_required": "Please enter the new amount",
    "measure_value_positive": "Please enter a positive amount",
    "checkin_date_required": "Please enter a checkin date"
  },
  "actions": {
    "edit": "Edit",
    "archive": "Archive",
    "unarchive": "Unarchive",
    "delete": "Delete Objective",
    "create": "Create an Objective",
    "link_workspace": "Link to workspace",
    "unlink_workspace": "unlink project"
  },
  "labels": {
    "description": "Description",
    "owners": "Owners",
    "measure": "Measure",
    "progress": "Progress",
    "workspaces": "Workspaces",
    "current": "Current",
    "target": "Target",
    "target_date": "Target date",
    "status": "Status",
    "group_by": "Group by",
    "filter": "Filter",
    "workspace": "workspace"
  },
  "group_by": {
    "department": "Department",
    "office": "Office",
    "owner": "Owner"
  },
  "status": {
    "active": "Active",
    "archived": "Archived"
  },
  "messages": {
    "stay_focused": "Stay focused on what matters and reach our objectives.",
    "use_tracker": "Use NEXL's Objective Tracker to set your quarterly or yearly business objectives. Set revenue goals, business development goals or even personal goals. With Objectice Tracker it's easy to stay focused and track your progess.",
    "link_workspace_validation": "Please select a project"
  },
  "confirmations": {
    "archive_title": "Archive Objective",
    "archive_content": "Are you sure you want to archive this objective?",
    "unarchive_title": "Unarchive Objective",
    "unarchive_content": "Are you sure you want to unarchive this objective?",
    "delete_title": "Delete Objective",
    "delete_content": "Are you sure you want to delete this objective? All the data will be deleted and cannot be undone.",
    "unlink_workspace_title": "Are you sure you want to unlink this workspace?",
    "unlink_workspace_content": "You can always add it back later."
  },
  "aria_labels": {
    "objective_actions": "Objective actions",
    "link_workspace": "link workspace",
    "create_objective_progress": "create objective progress",
    "show_filters": "show filters",
    "filters_active": "{{status}} filters are active"
  },
  "filters": {
    "clear_filters": "Clear Filters"
  }
}
